export default {
  hero: {
    title: "Datenschutzerklärung"
  },
  toc: {
    title: "Inhalt"
  },
  sections: [
    {
      id: "section1",
      title: "1 Verantwortlicher",
      blocks: [
        "Verantwortlich für die Datenverarbeitung auf dieser Plattform ist:\n\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSchweiz"
      ]
    },
    {
      id: "section2",
      title: "2 Allgemeine Hinweise",
      blocks: [
        "Diese Datenschutzerklärung informiert darüber, wie personenbezogene Daten im Zusammenhang mit der Nutzung von NutriBot erhoben, verarbeitet und verwendet werden.",
        "Mit der Nutzung der Plattform erklärt sich der Nutzer mit der Datenverarbeitung gemäss dieser Datenschutzerklärung einverstanden."
      ]
    },
    {
      id: "section3",
      title: "3 Arten der verarbeiteten Daten",
      blocks: [
        "Es können insbesondere folgende Daten verarbeitet werden:",
        "**3.1 Kontodaten**",
        [
          "Name",
          "E-Mail-Adresse",
          "Zugangsdaten"
        ],
        "**3.2 Nutzungsdaten**",
        [
          "Eingaben und generierte Inhalte",
          "Interaktionen mit der Plattform",
          "Nutzungsverhalten"
        ],
        "**3.3 Gesundheitsbezogene Angaben**",
        [
          "Körpergewicht",
          "Körpergrösse",
          "freiwillig eingegebene ernährungsbezogene oder körperbezogene Informationen"
        ],
        "Diese Daten können Rückschlüsse auf den Gesundheitszustand zulassen.",
        "**3.4 Technische Daten**",
        [
          "IP-Adresse",
          "Gerätetyp",
          "Browsertyp",
          "Betriebssystem",
          "Zeitstempel"
        ],
        "**3.5 Zahlungsdaten**",
        [
          "Abrechnungsinformationen",
          "Abonnementstatus"
        ],
        "Zahlungsdaten werden durch externe Zahlungsanbieter verarbeitet."
      ]
    },
    {
      id: "section4",
      title: "4 Zweck der Datenverarbeitung",
      blocks: [
        "Die Verarbeitung erfolgt zu folgenden Zwecken:",
        [
          "Bereitstellung und Betrieb der Plattform",
          "Generierung von Inhalten",
          "Verbesserung von Systemleistung und Funktionen",
          "Gewährleistung der Sicherheit und Missbrauchsprävention",
          "Abwicklung von Zahlungen und Abonnements",
          "Erfüllung gesetzlicher Verpflichtungen"
        ]
      ]
    },
    {
      id: "section5",
      title: "5 Rechtsgrundlagen",
      blocks: [
        "Die Verarbeitung erfolgt auf Basis von:",
        [
          "Vertragserfüllung",
          "berechtigten Interessen",
          "gesetzlichen Verpflichtungen"
        ],
        "Gesundheitsbezogene Daten werden ausschliesslich auf Grundlage der ausdrücklichen Einwilligung des Nutzers verarbeitet.",
        "Die Eingabe dieser Daten erfolgt freiwillig."
      ]
    },
    {
      id: "section6",
      title: "6 Weitergabe von Daten",
      blocks: [
        "Personenbezogene Daten können an folgende Empfänger weitergegeben werden:",
        [
          "Hosting-Anbieter",
          "Zahlungsdienstleister",
          "Analyse- und Tracking-Anbieter",
          "IT- und Sicherheitsdienstleister"
        ],
        "Die Weitergabe erfolgt nur im erforderlichen Umfang."
      ]
    },
    {
      id: "section7",
      title: "7 Datenübermittlung ins Ausland",
      blocks: [
        "Daten können in Länder ausserhalb der Schweiz oder des Europäischen Wirtschaftsraums übermittelt werden.",
        "In solchen Fällen werden angemessene Schutzmassnahmen getroffen, insbesondere:",
        [
          "Standardvertragsklauseln",
          "gleichwertige gesetzliche Schutzmechanismen"
        ]
      ]
    },
    {
      id: "section8",
      title: "8 Speicherdauer",
      blocks: [
        "Personenbezogene Daten werden nur so lange gespeichert, wie es erforderlich ist für:",
        [
          "die Bereitstellung der Dienste",
          "die Erfüllung gesetzlicher Pflichten",
          "die Durchsetzung oder Abwehr von Ansprüchen"
        ]
      ]
    },
    {
      id: "section9",
      title: "9 Datensicherheit",
      blocks: [
        "Es werden angemessene technische und organisatorische Massnahmen eingesetzt, um Daten zu schützen vor:",
        [
          "unbefugtem Zugriff",
          "Verlust",
          "Missbrauch",
          "Veränderung"
        ],
        "Eine vollständige Sicherheit kann jedoch nicht garantiert werden."
      ]
    },
    {
      id: "section10",
      title: "10 Rechte der Nutzer",
      blocks: [
        "Nutzer haben im Rahmen der anwendbaren Gesetze folgende Rechte:",
        [
          "Auskunft über gespeicherte Daten",
          "Berichtigung unrichtiger Daten",
          "Löschung von Daten",
          "Einschränkung der Verarbeitung",
          "Datenübertragbarkeit",
          "Widerspruch gegen die Verarbeitung"
        ],
        "Anfragen können an den Verantwortlichen gerichtet werden."
      ]
    },
    {
      id: "section11",
      title: "11 Automatisierte Verarbeitung",
      blocks: [
        "NutriBot nutzt automatisierte Systeme, einschliesslich künstlicher Intelligenz.",
        "Es werden keine rechtlich bindenden Entscheidungen ausschliesslich auf Grundlage automatisierter Verarbeitung getroffen."
      ]
    },
    {
      id: "section12",
      title: "12 Cookies und Tracking",
      blocks: [
        "Die Plattform kann Cookies und ähnliche Technologien verwenden für:",
        [
          "Funktionalität",
          "Analyse",
          "Optimierung"
        ],
        "Die Steuerung erfolgt über die Einstellungen des Browsers oder entsprechende Consent-Mechanismen."
      ]
    },
    {
      id: "section13",
      title: "13 Drittanbieter",
      blocks: [
        "Die Plattform kann Dienste von Drittanbietern integrieren.",
        "Diese können Daten eigenständig gemäss ihren jeweiligen Datenschutzbestimmungen verarbeiten."
      ]
    },
    {
      id: "section14",
      title: "14 Umgang mit gesundheitsbezogenen Daten",
      blocks: [
        "Gesundheitsbezogene Daten werden:",
        [
          "ausschliesslich zur Bereitstellung der Funktionen von NutriBot verwendet",
          "nicht für medizinische Zwecke verwendet",
          "nicht zur Erstellung medizinischer Profile verwendet"
        ],
        "Der Nutzer bestätigt ausdrücklich:",
        [
          "dass die Eingabe dieser Daten freiwillig erfolgt",
          "dass keine medizinische Bewertung erfolgt",
          "dass die Nutzung auf eigenes Risiko erfolgt"
        ]
      ]
    },
    {
      id: "section15",
      title: "15 Änderungen",
      blocks: [
        "Diese Datenschutzerklärung kann jederzeit angepasst werden.",
        "Die jeweils aktuelle Version ist verbindlich."
      ]
    },
    {
      id: "section16",
      title: "16 Kontakt",
      blocks: [
        "Für datenschutzbezogene Anliegen:\n\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSchweiz"
      ]
    }
  ],
  finalStatement: "Abschliessende Klarstellung\n\nDie Nutzung von NutriBot setzt voraus, dass die Verarbeitung personenbezogener Daten technisch notwendig ist und nicht ausgeschlossen werden kann."
};